module.exports = __webpack_public_path__ + "img/6-3.a86b0ed7.png";